import { makeRequest, buildResponse, buildError } from 'helpers/requestHandler'

export default class Timetables {
	list(key) {
		return new Promise((resolve, reject) => {
			makeRequest('/timetables/tables/list', 'POST', {
				'key': key
			}).then((response) => {
				if (response.ok) {
					response.json().then((json) => resolve(buildResponse(true, json)))
				} else {
					switch (response.status) {
						case 403:
							return buildError(response, reject, 'Not enough permissions to perform operation')
						default:
							return buildError(response, reject, 'Unknown')
					}
				}
			})
		})
	}

	create(name, bank, date_from, date_to, days_run, filters, key) {
		return new Promise((resolve, reject) => {
			makeRequest('/timetables/tables/create', 'POST', {
				'key': key,
				'bank_id': bank,
				'date_from': date_from,
				'date_to': date_to,
				'days_run': days_run,
				'name': name,
				'filters': (filters != null ? filters : undefined)
			}).then((response) => {
				if (response.ok) {
					response.json().then((json) => resolve(buildResponse(true, json)))
				} else {
					switch (response.status) {
						case 403:
							return buildError(response, reject, 'Not enough permissions to perform operation')
						case 404:
							return buildError(response, reject, 'The requested data file cannot be found')
						case 410:
							return buildError(response, reject, 'The requested bank is not valid')
						default:
							return buildError(response, reject, 'Unknown')
					}
				}
			})
		})
	}

	delete(id, key) {
		return new Promise((resolve, reject) => {
			makeRequest('/timetables/tables/delete', 'POST', {
				'key': key,
				'unique_id': id
			}).then((response) => {
				if (response.ok) {
					response.json().then((json) => resolve(buildResponse(true, json)))
				} else {
					switch (response.status) {
						case 403:
							return buildError(response, reject, 'Not enough permissions to perform operation')
						case 404:
							return buildError(response, reject, 'Timetable cannot be found')
						default:
							return buildError(response, reject, 'Unknown')
					}
				}
			})
		})
	}

	undelete(id, key) {
		return new Promise((resolve, reject) => {
			makeRequest('/timetables/tables/undelete', 'POST', {
				'key': key,
				'unique_id': id
			}).then((response) => {
				if (response.ok) {
					response.json().then((json) => resolve(buildResponse(true, json)))
				} else {
					switch (response.status) {
						case 403:
							return buildError(response, reject, 'Not enough permissions to perform operation')
						case 404:
							return buildError(response, reject, 'Timetable cannot be found')
						default:
							return buildError(response, reject, 'Unknown')
					}
				}
			})
		})
	}

	view(id, key) {
		return new Promise((resolve, reject) => {
			makeRequest('/timetables/tables/view', 'POST', {
				'key': key,
				'unique_id': id
			}).then((response) => {
				if (response.ok) {
					response.json().then((json) => resolve(buildResponse(true, json)))
				} else {
					switch (response.status) {
						case 403:
							return buildError(response, reject, 'Not enough permissions to perform operation')
						case 404:
							return buildError(response, reject, 'Timetable does not exist ')
						default:
							return buildError(response, reject, 'Unknown')
					}
				}
			})
		})
	}

	checkStatus(id, key) {
		return new Promise((resolve, reject) => {
			makeRequest('/timetable/tables/status', 'POST', {
				'key': key,
				'unique_id': id
			}).then(response => {
				if (response.ok) {
					response.json().then(json => resolve(buildResponse(true, json)))
				} else {
					switch (response.status) {
						case 403:
							return buildError(response, reject, 'Operation not permitted')
						case 410:
							return buildError(response, reject, 'Timetable does not exist')
						default:
							return buildError(response, reject, 'Unknown')
					}
				}
			})
		})
	}

	dataList(key) {
		return new Promise((resolve, reject) => {
			makeRequest('/timetables/tables/datafiles', 'POST', {
				'key': key
			}).then((response) => {
				if (response.ok) {
					response.json().then((json) => resolve(buildResponse(true, json)))
				} else {
					switch (response.status) {
						case 403:
							return buildError(response, reject, 'Not enough permissions to perform operation')
						default:
							return buildError(response, reject, 'Unknown')
					}
				}
			})
		})
	}

	queueConnections(timetable, key) {
		return new Promise((resolve, reject) => {
			makeRequest('/timetables/tables/queue_connections', 'POST', {
				'key': key,
				'unique_id': timetable.id
			}).then((response) => {
				if (response.ok) {
					response.json().then((json) => resolve(buildResponse(true, json)))
				} else {
					switch (response.status) {
						case 400:
							return buildError(response, reject, 'Timetable ID is missing')
						case 404:
							return buildError(response, reject, 'Timetable does not exist')
						case 401:
							return buildError(response, reject, 'Timetable not ready for connections')
						default:
							return buildError(response, reject, 'Unknown')
					}
				}
			})
		})
	}

	regenerate(timetable, key) {
		return new Promise((resolve, reject) => {
			makeRequest('/timetables/tables/regenerate', 'POST', {
				'key': key,
				'unique_id': timetable.id
			}).then((response) => {
				if (response.ok) {
					response.json().then((json) => resolve(buildResponse(true, json)))
				} else {
					switch (response.status) {
						case 400:
							return buildError(response, reject, 'Timetable ID is missing')
						case 404:
							return buildError(response, reject, 'Timetable does not exist')
						case 401:
							return buildError(response, reject, 'Timetable cannot be regenerated')
						default:
							return buildError(response, reject, 'Unknown')
					}
				}
			})
		})
	}

	column = {
		move: (timetable, column_id, new_position_column_id, key) => {
			return new Promise((resolve, reject) => {
				makeRequest('/timetables/tables/column/move', 'POST', {
					'key': key,
					'timetable_id': timetable.id,
					'column_id': column_id,
					'new_position': new_position_column_id,
				}).then((response) => {
					if (response.ok) {
						response.json().then((json) => resolve(buildResponse(true, json)))
					} else {
						switch (response.status) {
							case 400:
								return buildError(response, reject, 'Missing fields')
							case 404:
								return buildError(response, reject, 'Cannot find Timetable or Column')
							case 403:
								return buildError(response, reject, 'No permissions to access feature')
							case 409:
								return buildError(response, reject, 'Update not possible')
							case 410:
								return buildError(response, reject, 'Timetable or Column does not exist')
							default:
								return buildError(response, reject, 'Unknown')
						}
					}
				})
			})
		},
		suppress: (timetable, column, key) => {
			return new Promise((resolve, reject) => {
				makeRequest('/timetables/tables/column/suppress', 'POST', {
					'key': key,
					'timetable_id': timetable.id,
					'column_id': column.id
				}).then((response) => {
					if (response.ok) {
						response.json().then((json) => resolve(buildResponse(true, json)))
					} else {
						switch (response.status) {
							case 400:
								return buildError(response, reject, 'Missing fields')
							case 404:
								return buildError(response, reject, 'Cannot find Timetable or Column')
							case 403:
								return buildError(response, reject, 'No permissions to access feature')
							case 409:
								return buildError(response, reject, 'Update not possible')
							case 410:
								return buildError(response, reject, 'Timetable or Column does not exist')
							default:
								return buildError(response, reject, 'Unknown')
						}
					}
				})
			})
		},
		timing: {
			edit: (timetableID, columnID, timing, key) => {
				return new Promise((resolve, reject) => {
					const {time_arr, time_dep, connection, note, suppress, service, services} = timing
					makeRequest('/timetables/tables/edit/time', 'POST', {
						'key': key,
						'timetable_id': timetableID,
						'column_id': columnID,
						'time_id': timing.time_id,
						'data': {
							time_arr,
							time_dep,
							connection,
							note,
							suppress,
							service,
							services
						}
					}).then((response) => {
						if (response.ok) {
							response.json().then((json) => resolve(buildResponse(true, json)))
						} else {
							switch (response.status) {
								case 400:
									return buildError(response, reject, 'Missing fields')
								case 404:
									return buildError(response, reject, 'Cannot find Timetable or Column')
								case 403:
									return buildError(response, reject, 'No permissions to access feature')
								case 409:
									return buildError(response, reject, 'Update not possible')
								case 410:
									return buildError(response, reject, 'Timetable or Column does not exist')
								default:
									return buildError(response, reject, 'Unknown')
							}
						}
					})
				})
			}
		}
	}

	filters = {
		toc: {
			list: (key) => {
				return new Promise((resolve, reject) => {
					makeRequest('/timetables/filters/toc/list', 'POST', {
						'key': key,
					}).then((response) => {
						if (response.ok) {
							response.json().then((json) => resolve(buildResponse(true, json)))
						} else {
							switch (response.status) {
								case 404:
									return buildError(response, reject, 'No filters available')
								default:
									return buildError(response, reject, 'Unknown')
							}
						}
					})
				})
			},
			create: (code, name, key) => {
				return new Promise((resolve, reject) => {
					makeRequest('/timetables/filters/toc/create', 'POST', {
						'key': key,
						'code': code,
						'name': name
					}).then((response) => {
						if (response.ok) {
							response.json().then((json) => resolve(buildResponse(true, json)))
						} else {
							switch (response.status) {
								case 412:
									return buildError(response, reject, 'TOC code unknown')
								case 400:
									return buildError(response, reject, 'Missing fields')
								default:
									return buildError(response, reject, 'Unknown')
							}
						}
					})
				})
			}
		},
		headcode: {
			list: (key) => {
				return new Promise((resolve, reject) => {
					makeRequest('/timetables/filters/headcode/list', 'POST', {
						'key': key,
					}).then((response) => {
						if (response.ok) {
							response.json().then((json) => resolve(buildResponse(true, json)))
						} else {
							switch (response.status) {
								case 404:
									return buildError(response, reject, 'No filters available')
								default:
									return buildError(response, reject, 'Unknown')
							}
						}
					})
				})
			},
			create: (code, name, key) => {
				return new Promise((resolve, reject) => {
					makeRequest('/timetables/filters/headcode/create', 'POST', {
						'key': key,
						'headcode': code,
						'name': name
					}).then((response) => {
						if (response.ok) {
							response.json().then((json) => resolve(buildResponse(true, json)))
						} else {
							switch (response.status) {
								case 400:
									return buildError(response, reject, 'Missing fields')
								case 412:
									return buildError(response, reject, 'Headcode unknown')
								default:
									return buildError(response, reject, 'Unknown')
							}
						}
					})
				})
			}
		},
		remove: (timetableId, filterId, key) => {
			return new Promise((resolve, reject) => {
				makeRequest('/timetables/tables/filters/remove', 'POST', {
					key: key,
					timetable_id: timetableId,
					filter_id: filterId
				}).then((response) => {
					if (response.ok) {
						response.json().then((json) => resolve(buildResponse(true, json)))
					} else {
						switch (response.status) {
							default:
								return buildError(response, reject, 'Unknown')
						}
					}
				})
			})
		}
	}

}


// WEBPACK FOOTER //
// ./src/thunks/classes/Timetable.js